<template>
  <div class="table-page-container tenant-invoice-page">
    <div class="search-box">
      <el-form :model="queryData" class="search-form" @submit.native.prevent="handleSearch">
        <div class="search-main-grid">
          <div class="field-item"><el-date-picker v-model="queryData.timeRange" type="daterange" range-separator="-" start-placeholder="申请开始日期" end-placeholder="申请结束日期" value-format="yyyy-MM-dd" size="small" style="width: 100%" @change="handleSearch" /></div>
          <div class="field-item"><el-input v-model="queryData.fphm" clearable placeholder="发票号码" size="small" @keyup.enter.native="handleSearch" /></div>
          <div class="field-item"><el-input v-model="queryData.tenantName" clearable placeholder="租户名称" size="small" @keyup.enter.native="handleSearch" /></div>
          <div class="field-item"><el-select v-model="queryData.status" clearable placeholder="开票状态" size="small" @change="handleSearch"><el-option v-for="item in invoiceStatuses" :key="item.value" :label="item.label" :value="item.value" /></el-select></div>
          <div class="search-actions">
            <button type="button" class="toggle-advanced" :aria-expanded="showAdvanced ? 'true' : 'false'" @click="showAdvanced = !showAdvanced">{{ showAdvanced ? '收起' : '展开' }} <i :class="showAdvanced ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" /></button>
            <el-button type="primary" size="small" icon="el-icon-search" :disabled="!currentManagerId || auditSubmitting" @click="handleSearch">查询</el-button>
            <el-button size="small" icon="el-icon-refresh" :disabled="auditSubmitting" @click="handleReset">重置</el-button>
            <el-button type="success" size="small" icon="el-icon-download" :loading="exporting" :disabled="loading || !tableData.length" @click="handleExport">导出本页</el-button>
          </div>
          <template v-if="showAdvanced">
            <div class="field-item"><el-input v-model="queryData.tenantId" clearable placeholder="租户编号" size="small" @keyup.enter.native="handleSearch" /></div>
            <div class="field-item"><el-input v-model="queryData.enterpriseName" clearable placeholder="发票抬头" size="small" @keyup.enter.native="handleSearch" /></div>
            <div class="field-item"><el-select v-model="queryData.suject" clearable placeholder="费用类型" size="small" @change="handleSearch"><el-option v-for="item in invoiceSubjects" :key="item.value" :label="item.label" :value="item.value" /></el-select></div>
            <div class="field-item"><el-select v-model="queryData.fplxdm" clearable placeholder="发票类型" size="small" @change="handleSearch"><el-option label="增值税普通发票" value="02" /><el-option label="增值税专用发票" value="028" /></el-select></div>
          </template>
        </div>
      </el-form>
    </div>
    <div class="content-box">
      <div class="content-toolbar">
        <div class="toolbar-left"><span class="section-title"><span class="title-bar" />开票申请</span><el-tag v-if="pendingCount !== null" size="small" type="warning" class="pending-tag">待审核 {{ pendingCount }}</el-tag></div>
        <div class="toolbar-right"><el-button size="small" icon="el-icon-refresh" :loading="loading" :disabled="auditSubmitting" @click="reload">刷新</el-button><span class="muted">按申请时间倒序</span></div>
      </div>
      <el-alert v-if="loadError" :title="loadError" type="error" :closable="false" show-icon class="load-error"><el-button type="text" @click="reload">重新加载</el-button></el-alert>
      <div v-if="selectedData.length" class="selection-toolbar">
        <span class="selection-info">已选择 <span class="count">{{ selectedData.length }}</span> 条</span>
        <!-- 暂停批量审核，仅保留逐条审核入口。
        <el-button size="mini" :disabled="loading || auditSubmitting" @click="openAudit(selectedData, 1)">批量通过</el-button>
        <el-button size="mini" type="danger" plain :disabled="loading || auditSubmitting" @click="openAudit(selectedData, 3)">批量拒绝</el-button>
        -->
      </div>
      <div class="list-view">
        <el-table ref="table" v-loading="loading" :data="tableData" row-key="id" border stripe size="small" class="custom-table light-border-table" :header-cell-style="{ background: '#f5f7fa', color: '#606266', fontWeight: '600' }" :empty-text="emptyText" @selection-change="selectedData = $event">
          <el-table-column type="selection" width="50" align="center" :selectable="selectable" />
          <el-table-column label="申请编号" width="130" fixed="left" align="center"><template slot-scope="{ row }"><el-button type="text" @click="handleDetail(row)">{{ row.id }}</el-button></template></el-table-column>
          <el-table-column label="申请时间" width="165" align="center"><template slot-scope="{ row }">{{ displayTime(row.createTime) }}</template></el-table-column>
          <el-table-column prop="tenantId" label="租户编号" width="115" align="center" />
          <el-table-column prop="tenantName" label="租户名称" min-width="180" show-overflow-tooltip />
          <el-table-column label="开票金额" width="130" align="right"><template slot-scope="{ row }"><span class="amount-text text-warning">{{ money(row.invoiceAmt) }}</span></template></el-table-column>
          <el-table-column label="开票状态" width="100" align="center"><template slot-scope="{ row }"><el-tag size="small" effect="plain" :type="statusTag(row.status)">{{ statusLabel(row.status) }}</el-tag></template></el-table-column>
          <el-table-column label="费用类型" width="110" align="center"><template slot-scope="{ row }">{{ subjectLabel(row.suject) }}</template></el-table-column>
          <el-table-column label="开票方式" width="125" align="center"><template slot-scope="{ row }">{{ billTypeLabel(row.billType) }}</template></el-table-column>
          <el-table-column label="发票类型" width="155" align="center"><template slot-scope="{ row }">{{ invoiceTypeLabel(row.fplxdm) }}</template></el-table-column>
          <el-table-column label="抬头类型" width="90" align="center"><template slot-scope="{ row }">{{ titleTypeLabel(row.invoiceTitleType) }}</template></el-table-column>
          <el-table-column prop="enterpriseName" label="发票抬头" min-width="190" show-overflow-tooltip />
          <el-table-column prop="enterpriseTaxID" label="税号" min-width="180" show-overflow-tooltip />
          <el-table-column prop="billFullName" label="发票项目" min-width="170" show-overflow-tooltip />
          <el-table-column prop="billTariff" label="发票税率" width="90" align="center" />
          <el-table-column prop="fphm" label="发票号码" min-width="170" show-overflow-tooltip />
          <el-table-column label="发票性质" width="100" align="center"><template slot-scope="{ row }">{{ recordTypeLabel(row.type) }}</template></el-table-column>
          <el-table-column prop="userName" label="操作人" width="100" show-overflow-tooltip />
          <el-table-column label="最近操作时间" width="165"><template slot-scope="{ row }">{{ displayTime(row.updateTime) }}</template></el-table-column>
          <el-table-column prop="bz" label="备注" min-width="150" show-overflow-tooltip />
          <el-table-column prop="errorMsg" label="异常信息" min-width="180" show-overflow-tooltip />
          <el-table-column label="操作" width="190" fixed="right" align="center">
            <template slot-scope="{ row }">
              <div class="table-actions-group">
                <el-button type="text" size="small" class="op-btn primary-btn" @click="handleDetail(row)">详情</el-button>
                <template v-if="canAudit(row, currentManagerId) || needsManual(row)">
                  <el-divider direction="vertical" />
                  <el-button v-if="needsManual(row)" type="text" size="small" class="op-btn primary-btn" :disabled="auditSubmitting" @click="openManual(row)">补录发票</el-button>
                  <el-button v-else type="text" size="small" class="op-btn primary-btn" :disabled="auditSubmitting" @click="openAudit([row])">审核</el-button>
                </template>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-container compact-pagination"><el-pagination :current-page="pageData.current" :page-sizes="[15, 30, 60, 100]" :page-size="pageData.size" :total="pageData.total" layout="total, sizes, prev, pager, next, jumper" :disabled="loading || auditSubmitting" @size-change="handleSizeChange" @current-change="handleCurrentChange" /></div>
      </div>
    </div>
    <tenant-invoice-detail-drawer :visible.sync="detailVisible" :record="detailRecord" :manager-id="currentManagerId || ''" @audit="openAudit([$event])" />
    <el-dialog :visible.sync="auditVisible" width="620px" top="10vh" append-to-body class="invoice-audit-dialog" :close-on-click-modal="false" :close-on-press-escape="!auditSubmitting" :show-close="!auditSubmitting" :before-close="closeAudit">
      <div slot="title" class="audit-dialog-heading"><span class="audit-heading-icon"><i class="el-icon-document-checked" /></span><div><div class="audit-heading-title">{{ auditTargets.length > 1 ? '批量审核开票申请' : '审核开票申请' }}</div><div class="audit-heading-caption">核对申请信息，选择处理意见</div></div></div>
      <template v-if="!auditResult">
        <div class="audit-application-card">
          <div class="audit-card-top"><span class="audit-card-label">本次审核金额</span><span class="audit-count">{{ auditTargets.length }} 笔申请</span></div>
          <div class="audit-card-amount">{{ auditAmount }}</div>
          <div v-if="auditTargets.length === 1" class="audit-info-grid">
            <div><span>申请租户</span><strong>{{ auditTargets[0].tenantName || auditTargets[0].tenantId }}</strong></div>
            <div><span>发票抬头</span><strong>{{ auditTargets[0].enterpriseName || '-' }}</strong></div>
            <div><span>开票方式</span><strong>{{ billTypeLabel(auditTargets[0].billType) }}</strong></div>
            <div><span>申请编号</span><strong>{{ auditTargets[0].id }}</strong></div>
          </div>
          <div v-else class="audit-batch-hint">将按所选申请逐笔处理，请核对选择范围。</div>
        </div>
        <el-form :model="auditForm" label-position="top" class="audit-decision-form">
          <el-form-item label="审核意见" required>
            <el-radio-group v-model="auditForm.status" :disabled="auditSubmitting" class="audit-decision-options">
              <el-radio v-if="!auditTargets.some(needsManual)" :label="1" border><span class="decision-option-text"><strong>审核通过</strong><small>提交至开票通道处理</small></span></el-radio>
              <el-radio :label="3" border><span class="decision-option-text"><strong>拒绝申请</strong><small>退回并告知租户原因</small></span></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="auditForm.status === 3" label="拒绝原因" required><el-input v-model="auditForm.refuseReason" type="textarea" :rows="3" maxlength="500" show-word-limit :disabled="auditSubmitting" placeholder="请填写拒绝原因，方便租户修改后重新申请" /></el-form-item>
        </el-form>
        <div v-if="auditForm.status === 1" class="audit-mail-option"><div class="audit-mail-copy"><i class="el-icon-message" /><div><strong>发送发票邮件</strong><span>{{ auditEmailHint }}</span></div></div><el-switch v-model="auditForm.isSentMail" :disabled="auditSubmitting" active-color="#1677ff" aria-label="发送发票邮件" /></div>
        <div class="audit-tip"><i class="el-icon-info" />通过后由开票通道处理，最终状态以查询结果为准。</div>
        <el-alert v-if="auditError" :title="auditError" type="error" :closable="false" show-icon />
      </template>
      <template v-else>
        <el-alert :title="auditResult" :type="auditFailures.length ? 'warning' : 'success'" :closable="false" show-icon />
        <div v-for="item in auditFailures" :key="item.id" class="audit-failure">申请 {{ item.id }}：{{ item.message }}</div>
        <p class="muted">请关闭后刷新查看最终状态，避免重复提交。</p>
      </template>
      <span slot="footer"><el-button size="small" :disabled="auditSubmitting" @click="auditVisible = false">{{ auditResult ? '关闭' : '取消' }}</el-button><el-button v-if="!auditResult" type="primary" size="small" :loading="auditSubmitting" @click="submitAudit">{{ auditSubmitting ? '正在处理' : '确认提交' }}</el-button></span>
    </el-dialog>
    <el-dialog :visible.sync="manualVisible" title="补录已开具发票" width="560px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" :show-close="!manualSubmitting" :before-close="closeManual">
      <el-alert title="适用于人工开票通道：请上传已实际开具的发票，并填写真实发票号码。" type="info" :closable="false" show-icon />
      <el-form label-width="90px" class="audit-form">
        <el-form-item label="发票号码" required><el-input v-model="manualForm.fphm" maxlength="50" :disabled="manualSubmitting" /></el-form-item>
        <el-form-item label="发票文件" required><admin-oss-upload v-if="manualVisible" ref="invoiceUpload" upload-type="pdf" oss-prefix="admin/tenant-invoice/" tip-text="请上传 PDF 发票文件" @uploadSuccess="manualForm.pdfUrl = $event.url" @removeUpload="manualForm.pdfUrl = ''" /></el-form-item>
      </el-form>
      <el-alert v-if="manualError" :title="manualError" type="error" :closable="false" />
      <span slot="footer"><el-button size="small" :disabled="manualSubmitting" @click="closeManual">取消</el-button><el-button type="primary" size="small" :loading="manualSubmitting" @click="submitManual">确认补录</el-button></span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api/tenantInvoice'
import AdminOssUpload from '@/components/AdminOssUpload'
import TenantInvoiceDetailDrawer from './components/TenantInvoiceDetailDrawer.vue'
import { getApiErrorMessage } from '@/utils/apiError'
import { invoiceStatuses, invoiceSubjects, money, displayTime, normalizeInvoice, canAudit, statusTag, statusLabel, subjectLabel, invoiceTypeLabel, titleTypeLabel, billTypeLabel, recordTypeLabel, buildInvoiceQuery, buildAuditRequest, safeFileUrl, hasValue } from './tenantInvoiceModel'

const emptyFilters = () => ({ timeRange: [], fphm: '', tenantName: '', tenantId: '', enterpriseName: '', status: '', suject: '', fplxdm: '' })
export default {
  name: 'TenantInvoice',
  components: { TenantInvoiceDetailDrawer, AdminOssUpload },
  data () {
    return {
      queryData: emptyFilters(),
      showAdvanced: false,
      invoiceStatuses,
      invoiceSubjects,
      tableData: [],
      selectedData: [],
      loading: false,
      loadError: '',
      pendingCount: null,
      pageData: { current: 1, size: 15, total: 0 },
      exporting: false,
      detailVisible: false,
      detailRecord: {},
      auditVisible: false,
      auditTargets: [],
      auditForm: { status: null, refuseReason: '', isSentMail: true },
      auditSubmitting: false,
      auditError: '',
      auditResult: '',
      auditFailures: [],
      manualVisible: false,
      manualRecord: {},
      manualForm: { fphm: '', pdfUrl: '' },
      manualSubmitting: false,
      manualError: '',
      scopeVersion: 0,
      listVersion: 0,
      pendingVersion: 0
    }
  },
  computed: {
    ...mapGetters('manager', ['currentManagerId']),
    emptyText () { return !this.currentManagerId ? '请先选择管理方' : this.loadError ? '数据加载失败，请重试' : '暂无开票申请' },
    auditAmount () {
      const values = this.auditTargets.map(row => row.invoiceAmt)
      return values.every(value => hasValue(value) && Number.isFinite(Number(value))) ? money(values.reduce((sum, value) => sum + Number(value), 0)) : '-'
    },
    auditEmailHint () { return this.auditTargets.length === 1 ? (this.auditTargets[0].email || '发送至申请中填写的接收邮箱') : '发送至各申请中填写的接收邮箱' }
  },
  watch: {
    currentManagerId: { immediate: true, handler () { this.resetScope() } }
  },
  beforeDestroy () { this.scopeVersion++; this.listVersion++; this.pendingVersion++ },
  methods: {
    money,
    displayTime,
    canAudit,
    statusTag,
    statusLabel,
    subjectLabel,
    invoiceTypeLabel,
    titleTypeLabel,
    billTypeLabel,
    recordTypeLabel,
    needsManual (row) { return row.provider === 1 && canAudit(row, this.currentManagerId, 5) },
    selectable (row) { return !this.loading && !this.auditSubmitting && canAudit(row, this.currentManagerId) && !this.needsManual(row) },
    resetScope () {
      this.scopeVersion++; this.listVersion++; this.pendingVersion++
      this.auditVisible = false; this.detailVisible = false; this.manualVisible = false
      this.auditSubmitting = false; this.manualSubmitting = false
      this.queryData = emptyFilters(); this.tableData = []; this.selectedData = []
      this.pendingCount = null; this.pageData.current = 1; this.pageData.total = 0
      this.loadError = ''; this.loading = false
      if (this.currentManagerId) this.reload()
    },
    reload () { return Promise.allSettled([this.fetchTableData(), this.fetchPending()]) },
    async fetchPending () {
      const version = ++this.pendingVersion
      if (!this.currentManagerId) return
      try {
        const { data } = await api.pending(this.currentManagerId)
        if (version === this.pendingVersion) this.pendingCount = hasValue(data) && Number.isFinite(Number(data)) ? Number(data) : null
      } catch (e) { if (version === this.pendingVersion) this.pendingCount = null }
    },
    async fetchTableData () {
      const version = ++this.listVersion
      this.selectedData = []
      if (this.$refs.table) this.$refs.table.clearSelection()
      if (!this.currentManagerId) { this.tableData = []; this.pageData.total = 0; return }
      this.loading = true; this.loadError = ''
      try {
        const tenantId = String(this.queryData.tenantId || '').trim()
        if (tenantId && !/^\d+$/.test(tenantId)) throw new Error('租户编号只能包含数字')
        const query = buildInvoiceQuery(this.currentManagerId, this.queryData, this.pageData)
        const { data } = await api.page(query)
        if (version !== this.listVersion) return
        if (!data || !Array.isArray(data.dataList) || !hasValue(data.total) || !Number.isFinite(Number(data.total))) throw new Error('开票列表返回格式异常')
        this.tableData = data.dataList.map(normalizeInvoice)
        this.pageData.total = Number(data.total)
      } catch (e) {
        if (version === this.listVersion) { this.tableData = []; this.pageData.total = 0; this.loadError = getApiErrorMessage(e, '开票列表加载失败') }
      } finally { if (version === this.listVersion) this.loading = false }
    },
    handleSearch () { this.pageData.current = 1; this.reload() },
    handleReset () { this.queryData = emptyFilters(); this.handleSearch() },
    handleSizeChange (size) { this.pageData.size = size; this.pageData.current = 1; this.fetchTableData() },
    handleCurrentChange (current) { this.pageData.current = current; this.fetchTableData() },
    handleDetail (row) { this.detailRecord = { ...row }; this.detailVisible = true },
    openAudit (rows, status = null) {
      if (this.auditSubmitting || !rows.length) return
      if (rows.length !== 1 || this.selectedData.length > 1) { this.$message.warning('只能选中一条操作'); return }
      if (!rows.every(row => canAudit(row, this.currentManagerId))) { this.$message.warning('申请状态已变更，请刷新后重试'); return }
      this.auditTargets = rows.map(row => ({ ...row }))
      this.auditForm = { status: rows.some(this.needsManual) ? 3 : status, refuseReason: '', isSentMail: true }
      this.auditError = ''; this.auditResult = ''; this.auditFailures = []
      this.auditVisible = true
    },
    closeAudit (done) { if (this.auditSubmitting) return; this.auditVisible = false; if (typeof done === 'function') done() },
    async latestRecord (row, managerId, expectedStatus = 1) {
      const { data } = await api.detail(row.id)
      if (!data || !hasValue(data.status) || !hasValue(data.billType)) throw new Error('申请最新状态返回不完整，请刷新后重试')
      const latest = normalizeInvoice({ ...row, ...data })
      if (!canAudit(latest, managerId, expectedStatus)) throw new Error('申请状态已变更或不属于当前管理方，请刷新后重试')
      return latest
    },
    async submitAudit () {
      if (this.auditSubmitting) return
      if (this.auditTargets.length !== 1 || this.selectedData.length > 1) { this.$message.warning('只能选中一条操作'); return }
      const form = { ...this.auditForm }
      try { this.auditTargets.forEach(row => buildAuditRequest(row, this.currentManagerId, form.status, form.refuseReason, form.isSentMail)) } catch (e) { this.auditError = e.message; return }
      const targets = this.auditTargets.map(row => ({ ...row }))
      const managerId = this.currentManagerId
      const scope = this.scopeVersion
      const failures = []
      let completed = 0
      this.auditSubmitting = true; this.auditError = ''
      for (const row of targets) {
        if (scope !== this.scopeVersion) break
        try {
          const latest = await this.latestRecord(row, managerId)
          if (scope !== this.scopeVersion) break
          if (form.status === 1 && this.needsManual(latest)) throw new Error('该申请需补录实际开具的发票，请单独处理')
          const { method, params } = buildAuditRequest(latest, managerId, form.status, form.refuseReason, form.isSentMail)
          await api[method](params)
          completed++
        } catch (e) {
          failures.push({ id: row.id, message: getApiErrorMessage(e, '提交失败，请查询最终状态后再操作') })
          // 请求异常后停止剩余批次，避免结果不明时继续扩大操作范围。
          break
        }
      }
      if (scope !== this.scopeVersion) return
      this.auditSubmitting = false
      this.auditFailures = failures
      const remaining = targets.length - completed - failures.length
      this.auditResult = `已提交 ${completed} 笔${failures.length ? `，失败或待确认 ${failures.length} 笔` : ''}${remaining ? `，未处理 ${remaining} 笔` : ''}`
      if (this.detailVisible) this.detailRecord = { ...this.detailRecord }
      await this.reload()
    },
    openManual (row) {
      if (this.selectedData.length > 1) { this.$message.warning('只能选中一条操作'); return }
      if (!this.needsManual(row)) return
      this.manualRecord = { ...row }; this.manualForm = { fphm: '', pdfUrl: '' }; this.manualError = ''; this.manualVisible = true
    },
    closeManual (done) {
      if (this.manualSubmitting || (this.$refs.invoiceUpload && this.$refs.invoiceUpload.uploading)) return
      this.manualVisible = false
      if (typeof done === 'function') done()
    },
    async submitManual () {
      if (this.manualSubmitting) return
      if (this.$refs.invoiceUpload && this.$refs.invoiceUpload.uploading) { this.manualError = '请等待发票文件上传完成'; return }
      const fphm = this.manualForm.fphm.trim()
      const pdfUrl = safeFileUrl(this.manualForm.pdfUrl)
      if (!fphm || !pdfUrl) { this.manualError = '请填写发票号码并上传 PDF 发票'; return }
      const scope = this.scopeVersion
      this.manualSubmitting = true; this.manualError = ''
      try {
        const latest = await this.latestRecord(this.manualRecord, this.currentManagerId, 5)
        if (scope !== this.scopeVersion) return
        if (!this.needsManual(latest)) throw new Error('该申请当前无需人工补录，请刷新后重试')
        await api.completeManual({ invoiceManageId: latest.id, fphm, pdfUrl })
        if (scope !== this.scopeVersion) return
        this.manualVisible = false
        this.$message.success('发票补录已提交')
        if (this.detailVisible) this.detailRecord = { ...this.detailRecord }
        await this.reload()
      } catch (e) { if (scope === this.scopeVersion) this.manualError = getApiErrorMessage(e, '发票补录失败，请查询最终状态后重试') } finally { if (scope === this.scopeVersion) this.manualSubmitting = false }
    },
    async handleExport () {
      if (!this.tableData.length || this.exporting) return
      const rows = this.tableData.map(row => ({ 申请编号: row.id, 申请时间: displayTime(row.createTime), 租户编号: row.tenantId, 租户名称: row.tenantName, '开票金额(元)': row.invoiceAmt, 开票状态: statusLabel(row.status), 费用类型: subjectLabel(row.suject), 开票方式: billTypeLabel(row.billType), 发票类型: invoiceTypeLabel(row.fplxdm), 抬头类型: titleTypeLabel(row.invoiceTitleType), 发票抬头: row.enterpriseName, 税号: row.enterpriseTaxID, 发票号码: row.fphm, 发票性质: recordTypeLabel(row.type), 接收邮箱: row.email, 接收手机: row.mobilePhone, 备注: row.bz }))
      this.exporting = true
      try {
        const XLSX = await import('xlsx')
        const book = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(book, XLSX.utils.json_to_sheet(rows), '开票申请')
        XLSX.writeFile(book, `租户开票申请_第${this.pageData.current}页.xlsx`)
      } catch (e) { this.$message.error('导出失败，请重试') } finally { this.exporting = false }
    }
  }
}
</script>
<style lang="scss" scoped>
.pending-tag { margin-left: 0; height: 24px; line-height: 22px; }
.muted { color: #909399; font-size: 12px; }
.load-error { margin-bottom: 12px; }
.audit-form { margin-top: 24px; }
.audit-failure { color: #e6a23c; line-height: 1.8; margin-top: 12px; overflow-wrap: anywhere; }
.invoice-audit-dialog {
  ::v-deep .el-dialog { max-width: calc(100vw - 40px); border-radius: 10px; overflow: hidden; }
  ::v-deep .el-dialog__header { padding: 22px 24px 18px; border-bottom: 1px solid #edf0f4; }
  ::v-deep .el-dialog__body { padding: 22px 24px; max-height: 68vh; overflow-y: auto; }
  ::v-deep .el-dialog__footer { padding: 16px 24px; background: #fff; border-top: 1px solid #edf0f4; }
  ::v-deep .el-dialog__footer .el-button { min-width: 84px; border-radius: 6px; }
  ::v-deep .el-dialog__footer .el-button--primary { background: #1677ff; border-color: #1677ff; }
}
.audit-dialog-heading { display: flex; align-items: center; gap: 12px; }
.audit-heading-icon { display: flex; align-items: center; justify-content: center; width: 40px; height: 40px; border-radius: 10px; background: #edf5ff; color: #1677ff; font-size: 22px; }
.audit-heading-title { font-size: 17px; line-height: 24px; font-weight: 600; color: #1f2937; }
.audit-heading-caption { font-size: 12px; color: #9099a8; margin-top: 2px; line-height: 18px; }
.audit-application-card { border: 1px solid #e6edf7; background: #f7faff; border-radius: 8px; padding: 18px 20px; }
.audit-card-top { display: flex; justify-content: space-between; align-items: center; gap: 12px; }
.audit-card-label { color: #738198; font-size: 13px; }
.audit-count { border: 1px solid #e0e9f7; background: #fff; padding: 3px 8px; border-radius: 5px; font-size: 12px; line-height: 18px; color: #59718f; }
.audit-card-amount { color: #172b4d; font-size: 30px; font-weight: 600; line-height: 42px; margin: 3px 0 16px; font-variant-numeric: tabular-nums; overflow-wrap: anywhere; }
.audit-info-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 14px 24px; border-top: 1px solid #e6edf7; padding-top: 16px; }
.audit-info-grid > div { display: flex; flex-direction: column; gap: 5px; min-width: 0; }
.audit-info-grid span { font-size: 12px; color: #8995a7; }
.audit-info-grid strong { font-size: 13px; font-weight: 500; color: #344258; line-height: 20px; overflow-wrap: anywhere; }
.audit-batch-hint { font-size: 13px; color: #738198; }
.audit-decision-form {
  margin-top: 22px;
  ::v-deep .el-form-item { margin-bottom: 18px; }
  ::v-deep .el-form-item__label { padding-bottom: 9px; color: #344258; font-size: 13px; line-height: 20px; font-weight: 500; }
  ::v-deep .el-form-item__content { line-height: normal; }
  ::v-deep .el-textarea__inner { border-radius: 6px; padding: 10px 12px; font-size: 13px; }
}
.audit-decision-options {
  display: flex; gap: 12px; width: 100%;
  ::v-deep .el-radio.is-bordered { display: flex; align-items: center; flex: 1; min-width: 0; height: auto; margin: 0; padding: 14px; border-radius: 7px; }
  ::v-deep .el-radio.is-bordered.is-checked { background: #f4f8ff; border-color: #1677ff; }
  ::v-deep .el-radio__label { padding-left: 10px; min-width: 0; }
}
.decision-option-text { display: flex; flex-direction: column; gap: 6px; white-space: normal; }
.decision-option-text strong { font-size: 13px; font-weight: 500; }
.decision-option-text small { font-size: 12px; color: #97a0ae; line-height: 17px; }
.audit-mail-option { display: flex; align-items: center; justify-content: space-between; gap: 16px; border: 1px solid #edf0f5; border-radius: 7px; padding: 14px; margin-top: 4px; }
.audit-mail-copy { display: flex; align-items: center; gap: 10px; min-width: 0; }
.audit-mail-copy > i { font-size: 18px; color: #8495ac; }
.audit-mail-copy > div { display: flex; flex-direction: column; gap: 5px; min-width: 0; }
.audit-mail-copy strong { color: #4b5b71; font-size: 13px; font-weight: 500; }
.audit-mail-copy span { color: #97a0ae; font-size: 12px; line-height: 17px; overflow-wrap: anywhere; }
.audit-tip { display: flex; align-items: flex-start; gap: 6px; color: #9aa4b3; font-size: 12px; line-height: 20px; margin-top: 18px; }
.audit-tip i { line-height: 20px; }
.table-page-container.tenant-invoice-page {
  padding: 16px;
  background: #f0f2f5;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.search-box {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  margin-bottom: 16px;
}

.search-form {
  margin: 0;

  .search-main-grid {
    width: 100%;
    display: grid;
    align-items: center;
    grid-template-columns: repeat(4, minmax(0, 1fr)) auto;
    gap: 10px;
  }

  .field-item {
    width: 100%;
    min-width: 0;

    ::v-deep .el-input,
    ::v-deep .el-select {
      width: 100%;
      display: block;
    }

    ::v-deep .el-input__inner,
    ::v-deep .el-select .el-input__inner,
    ::v-deep .el-range-editor.el-input__inner {
      height: 32px;
      line-height: 32px;
      border-radius: 6px;
      border-color: #e4e7ed;
      font-size: 13px;
    }

    ::v-deep .el-range-editor--small.el-input__inner {
      height: 32px;
      line-height: 32px;
    }

    ::v-deep .el-range-separator {
      line-height: 24px;
    }
  }

  .search-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    white-space: nowrap;
    justify-self: start;
    grid-column: 5;
    line-height: 1;

    .toggle-advanced { display: inline-flex; align-items: center; gap: 3px; border: 0; padding: 0; margin: 0 6px 0 8px; background: transparent; color: #409eff; font-size: 13px; font-family: inherit; cursor: pointer; white-space: nowrap; height: 32px; }
    .toggle-advanced:hover { color: #66b1ff; }
    .toggle-advanced:focus-visible { outline: 2px solid #91caff; outline-offset: 3px; border-radius: 2px; }

    ::v-deep .el-button + .el-button {
      margin-left: 0 !important;
    }

    ::v-deep .el-button {
      height: 32px;
      padding: 0 14px;
      font-size: 13px;
      border-radius: 6px;
    }

    ::v-deep .el-button--primary {
      background: #1677ff;
      border-color: #1677ff;
      &:hover {
        background: #4096ff;
        border-color: #4096ff;
      }
    }

    ::v-deep .el-button--success {
      background: #52c41a;
      border-color: #52c41a;
      &:hover {
        background: #73d13d;
        border-color: #73d13d;
      }
    }
  }
}

.content-box {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  flex: 1;
  padding: 16px 16px 10px;
}

.content-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 8px 8px;
  flex-wrap: wrap;
  gap: 8px;

  .toolbar-left { display: flex; align-items: center; gap: 12px; min-height: 32px; }

  .toolbar-left .section-title {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 15px;
    font-weight: 600;
    color: #111827;

    .title-bar {
      width: 3px;
      height: 16px;
      background: #1677ff;
      border-radius: 2px;
      flex-shrink: 0;
    }
  }

  .toolbar-right {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
  }

  .toolbar-right ::v-deep .el-select .el-input__inner {
    height: 32px;
    line-height: 32px;
    font-size: 13px;
    border-radius: 6px;
    border-color: #e4e7ed;
  }

  ::v-deep .el-button--primary {
    background: #1677ff;
    border-color: #1677ff;
    &:hover {
      background: #4096ff;
      border-color: #4096ff;
    }
  }
}

.selection-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  padding: 0 8px 10px;
  margin-top: -4px;

  .selection-info {
    font-size: 13px;
    color: #606266;
    .count {
      color: #1677ff;
      font-weight: 600;
    }
  }
}

.list-view {
  padding: 0;
}

.light-border-table {
  margin-top: 8px;

  ::v-deep {
    border: 1px solid #f0f0f0 !important;

    .el-table__header-wrapper th {
      border-right: 1px solid #f0f0f0 !important;
      border-bottom: 1px solid #f0f0f0 !important;
    }

    td {
      border-right: 1px solid #f5f5f5 !important;
      border-bottom: 1px solid #f5f5f5 !important;
    }

    .el-table__body tr.el-table__row--striped > td {
      background: #fcfdff !important;
    }

    .el-table--enable-row-hover .el-table__body tr:hover > td {
      background: #f2f8ff !important;
    }
  }
}

.tenant-link {
  color: #1677ff !important;
  font-weight: 500;

  &:hover {
    color: #4096ff !important;
  }
}

.amount-text {
  font-weight: 500;
  color: #303133;

  &.text-danger {
    color: #f56c6c;
  }

  &.text-warning {
    color: #e6a23c;
  }
}

.text-primary {
  color: #1677ff;
}

.table-actions-group {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;

  .el-divider--vertical {
    height: 12px;
    margin: 0 8px;
  }

  .op-btn.primary-btn {
    color: #1677ff;
    padding: 0;
    font-size: 12px;

    &:hover {
      color: #4096ff;
    }
  }
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
  padding: 14px 0 4px;

  &.compact-pagination {
    ::v-deep .el-pagination {
      display: flex !important;
      align-items: center !important;
      font-size: 12px;

      span,
      button,
      .el-pager li,
      .el-pagination__total,
      .el-pagination__jump,
      .el-pagination__sizes,
      .el-pagination__sizes .el-input,
      .el-pagination__sizes .el-input__inner,
      .btn-prev,
      .btn-next {
        vertical-align: middle;
        display: inline-flex !important;
        align-items: center !important;
      }

      .el-pagination__total {
        font-size: 12px;
      }

      .el-pagination__sizes .el-input {
        width: 88px !important;
        min-width: 0 !important;

        .el-input__inner {
          height: 24px;
          font-size: 12px;
          padding: 0 8px;
          box-sizing: border-box;
        }
      }

      .btn-prev,
      .btn-next {
        min-width: 24px;
        height: 24px;
        font-size: 12px;
        padding: 0 6px;
      }

      .el-pager li {
        min-width: 24px;
        height: 24px;
        font-size: 12px;
        padding: 0 6px;
      }

      .el-pagination__jump {
        font-size: 12px;

        .el-input .el-input__inner {
          height: 24px;
          font-size: 12px;
          padding: 0 4px;
        }
      }
    }
  }
}

@media (max-width: 1300px) {
  .search-form .search-main-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .search-form .search-actions { grid-column: 1 / -1; grid-row: 1; justify-self: end; }
}
</style>
